import ClickAndCollectRepository from '../repositories/ClickAndCollectRepository';
import { diContainer, serviceNames } from '../diContainer/diContainer';
import TransactionLoadHandler, { ITransactionLoad } from './TransactionLoadHandler';
import BopisStoresRepository from '../repositories/BopisStoresRepository';
import { ADDRESS_TYPE_ID, FIELD_TYPE } from '../constants/Constants';
import SaveNewBillingAddressUseCase from './SaveNewBillingAddressUseCase';
import BillingRepository from '../repositories/BillingRepository';
import SubmitNewsletterUseCase from './SubmitNewsletterUseCase';

export const PURCHASER_FORM_ERROR = 'PURCHASER_FORM_ERROR';
export const BILLING_FORM_ERROR = 'BILLING_FORM_ERROR';

const transactionLoadUseCaseOptions: ITransactionLoad = {
  transactionLoadOptions: {
    isEnabled: false,
  },
};

class SetClickAndCollectStoreUseCase extends TransactionLoadHandler {

  private clickAndCollectRepository: ClickAndCollectRepository;

  private bopisStoresRepository: BopisStoresRepository;

  private billingRepository: BillingRepository;

  constructor() {
    super({
      isControlled: true,
      shouldAwait: true,
    });
    this.clickAndCollectRepository = diContainer.get(serviceNames.clickAndCollectRepository);
    this.bopisStoresRepository = diContainer.get(serviceNames.bopisStoresRepository);
    this.billingRepository = diContainer.get(serviceNames.billingRepository);
  }

  protected run = async (): Promise<void> => {
    let error: string;

    const transaction = await this.transactionRepository.getTransaction();
    const {
      billingAddress,
    } = transaction;

    if (billingAddress.isNewAddress && !this.billingRepository.formStore.isValid) {
      this.billingRepository.formStore.setShowErrors(true);
      error = BILLING_FORM_ERROR;
    }

    const {
      purchaserFormStore,
    } = this.bopisStoresRepository.bopisFormInfo;

    purchaserFormStore.runValidationSchemaSync();

    if (!this.bopisStoresRepository.bopisFormInfo.isValid) {
      purchaserFormStore.setShowErrors(!purchaserFormStore.isValid);
      if (!purchaserFormStore.isValid) {
        error = PURCHASER_FORM_ERROR;
      }
    }

    if (error) {
      throw new Error(error);
    }

    const { selectedStore } = this.bopisStoresRepository.bopisStoresCollection;
    const {
      firstName,
      lastName,
      phone,
    } = this.bopisStoresRepository?.bopisFormInfo?.purchaserFormStore?.values;

    const purchaserDetails = {
      firstName,
      lastName,
      phone,
    };

    const { shippingAddress } = this.transactionRepository.transaction;
    const addressType = shippingAddress?.attributes?.[FIELD_TYPE.ADDRESS_TYPE];
    let storeAddress;
    if (shippingAddress.id && addressType === ADDRESS_TYPE_ID.PACKSTATION) {
      storeAddress = await this.clickAndCollectRepository.updateClickAndCollectAddress(
        purchaserDetails,
        selectedStore.info,
        shippingAddress.id,
      );
    } else {
      storeAddress = await this.clickAndCollectRepository.setClickAndCollectAddress(
        purchaserDetails,
        selectedStore.info,
      );
    }

    transaction.setShippingAddress(storeAddress);

    const saveNewBillingAddressUseCase = new SaveNewBillingAddressUseCase(transactionLoadUseCaseOptions);
    await saveNewBillingAddressUseCase.execute();

    const submitNewsletterUseCase = new SubmitNewsletterUseCase();
    await submitNewsletterUseCase.execute();

    await this.handleTransactionUpdate();
  };
}

export default SetClickAndCollectStoreUseCase;
